/**
 * @returns if user uses application
 */
export function isApplication() {
  return navigator.userAgent == "hmcAppUserAgent";
}

/**
 * @returns if window is smaller then 1200px.
 */
export function isMobile() {
  return window.innerWidth < 1200;
}

/**
 * @returns mobile or desktop delay integer
 */
export function backClickTimeout() {
  return isMobile() ? 600 : 1500;
}

/**
 * @returns if event is number or not
 */
export function numbersOnly(ev) {
  ev = ev ? ev : window.event;
  var charCode = ev.which ? ev.which : ev.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    ev.preventDefault();
  } else {
    return true;
  }
}

/**
 * @returns menu list
 */
export const menuList = [
  {
    path: "/dashboard",
    title: "ניהול מרפאה"
  },
  {
    path: "/dashboard/surgeries",
    title: "חדרי ניתוח"
  },
  {
    path: "/surg-add-block",
    title: "הזמנת בלוק ניתוחים"
  },
  {
    path: "/table/appointment",
    title: "רשימת מטופלים - מרפאה"
  },
  {
    path: "/table/surgery",
    title: "רשימת מטופלים - ניתוח/פעולה"
  },
  {
    path: "/table/pathology",
    title: "דוחות פתולוגיה",
    type: "pathology"
  },
  {
    path: "/table/genetics",
    title: "דוחות מעבדה גנטית",
    type: "genetics"
  },
  {
    path: "/profile",
    title: "פרופיל רופא"
  },
  {
    path: "/contact",
    title: "יצירת קשר"
  },
  {
    path:
      "https://hmc-service.consist.co.il/UserSelfServiceActions.jsp?method=reset&step=1&noframe=YES",
    title: "איפוס סיסמה לקמיליון",
    target: "_blank"
  }
];

export const menuListMobile = [
  {
    isAccordion: true,
    title: "ניהול מרפאה",
    children: [
      {
        path: "/dashboard",
        title: "תצוגת יומן",
        isDateSvg: true
      },
      {
        path: "/dashboard/list",
        title: "רשימת תורים",
        isListSvg: true
      }
    ]
  },
  {
    isAccordion: true,
    title: "ניתוחים",
    children: [
      {
        path: "/dashboard/surgeries",
        title: "תצוגת יומן",
        isDateSvg: true
      },
      {
        path: "/dashboard/surgeries/list",
        title: "רשימת ניתוחים",
        isListSvg: true
      }
    ]
  },
  {
    path: "/surg-add-block",
    title: "הזמנת בלוק ניתוחים"
  },
  {
    isAccordion: true,
    title: "רשימת מטופלים",
    children: [
      {
        path: "/table/appointment",
        title: "מרפאה",
        isListSvg: true
      },
      {
        path: "/table/surgery",
        title: "ניתוח/פעולה",
        isListSvg: true
      }
    ]
  },
  {
    path: "/table/pathology",
    title: "דוחות פתולוגיה",
    type: "pathology"
  },
  {
    path: "/table/genetics",
    title: "דוחות מעבדה גנטית",
    type: "genetics"
  },
  {
    path: "/profile",
    title: "פרופיל רופא"
  },
  {
    path: "/contact",
    title: "יצירת קשר"
  },
  {
    path: "https://hmc-service.consist.co.il/passwordService.html",
    title: "איפוס סיסמה לקמיליון",
    target: "_blank"
  }
];

export function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
    reader.onerror = error => reject(error);
  });
}

export async function uploadDocuments(
  files,
  appointmentId,
  type = "medicaldocuments-patient",
  isSurgery = false
) {
  const ids = [];
  for (let i = 0; i < files.length; i++) {
    if (files[i] instanceof File) {
      const base64 = await convertToBase64(files[i]);
      try {
        const res = await this.$API.uploadFile(
          appointmentId,
          "new",
          null,
          files[i].name,
          base64,
          isSurgery,
          type
        );
        if (res?.status === "ok" && res?.errordesc?.document_id) {
          ids.push(res.errordesc.document_id);
        }
      } catch (error) {
        if (error.errordesc) return { error: error.errordesc };
        return { error: "התרחשה שגיאה בהעלאת הקובץ" };
      }
    }
  }
  return ids;
}
